import { SET_ROUTE_TAB, ADD_ROUTE_TAB, DEL_ROUTE_TAB, ROUTE_TABS } from '../mutation-types'
import store from 'store'
const state = {
    routes: []
}

const actions = {
    addRoute({ commit }, route) {
        commit(ADD_ROUTE_TAB, route)
    },
    delRoute({ commit }, route) {
        commit(DEL_ROUTE_TAB, route)
    }
}

const mutations = {
    [SET_ROUTE_TAB]: (state, tabs) => {
        state.routes = tabs || []
    },
    [ADD_ROUTE_TAB]: (state, route) => {
        if (route.name == 'workplace' || state.routes.some(r => r.name == route.name)) {
            return
        }
        state.routes.push(route)
        store.set(ROUTE_TABS, state.routes) // 存储到 localStorage
    },
    [DEL_ROUTE_TAB]: (state, route) => {
        state.routes.splice(state.routes.map(r => r.name).indexOf(route), 1)
        store.set(ROUTE_TABS, state.routes) // 存储到 localStorage
    },
}

const getters = {
    routes: state => state.routes,
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}